export default "__VITE_ASSET__DlCCgkUH__"